<template>
  <div>
    <v-app-bar
      class="color-app-bar" 
      app 
      dark>
      
      <v-app-bar-nav-icon 
        @click="menu" 
        v-if="isLogged">
      </v-app-bar-nav-icon>
      <v-toolbar-title> 
        <b><b>JIJE</b></b> UNL
      </v-toolbar-title>
      
      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!$vuetify.breakpoint.xsOnly"
            min-width="240px"
            outlined
            color="white"
            small
            v-show="isLogged"
            v-bind="attrs"
            v-on="on"
          >
            {{ (user!==null)?user.lastname+', '+user.name:'' }}
          </v-btn>

          <v-avatar 
            v-if="$vuetify.breakpoint.xsOnly"
            class="ma-2"
            v-show="isLogged"
            v-bind="attrs"
            v-on="on"
            size="42"
            color="white">
            <span class="black--text text-h7">
              {{ (user!==null)?user.name[0]+user.lastname[0]:'' }}
            </span>
          </v-avatar>
        </template>

        <v-list color="#1F5367">
          <v-list-item>
            <v-btn
              block
              outlined
              dark
              :to="{name: 'profile'}">
              Editar Perfíl
            </v-btn>
          </v-list-item>

          <v-list-item>
            <v-btn
              block
              outlined
              dark
              @click="changeEdition()">
              Otras Ediciones
            </v-btn>
          </v-list-item>

          <v-list-item>
            <v-btn
              block
              outlined
              dark
              :to="{name: 'messages'}">
              Mensajes
            </v-btn>
          </v-list-item>

          <v-list-item>
            <v-btn
              block
              outlined
              dark
              @click="logout">
              Cerrar sesión
            </v-btn>
          </v-list-item>
        </v-list>
        
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      dark
      app
      color="#00A1B8"
      v-model="drawer">

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-rocket-launch</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <h4>JIJE UNL</h4>
        </v-list-item-content>
      </v-list-item>

      <v-list dense nav>
        <div>  
          <v-divider></v-divider>
          
          <div>

            <v-list-item router :to="({ name: 'home' })">
              <v-list-item-icon>
                <v-icon>mdi-table-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Sala de Espera</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item router to="/about">
              <v-list-item-icon>
                <v-icon>mdi-information-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Acerca de JIJE UNL</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
              <v-list-item-title class="pl-8 pa-2">Ediciones</v-list-item-title>
            <v-divider></v-divider>

            <v-list-item router @click="changeEdition">
              <v-list-item-icon>
                <v-icon>mdi-home-switch-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Otra Edición</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </div>

        </div>
      </v-list>

    </v-navigation-drawer>

    <v-dialog
      v-model="change_edition"
      max-width="600px">
      <v-card :loading="loading_btn">
        <v-card-title>
          <span class="text-h5">Seleccione una edición:</span>
        </v-card-title>
        <v-card-text>

          <v-col cols="12">
            <v-btn 
              v-for="edition in editions"
              :key="edition.id"
              block
              x-large
              dark
              color="#0097B4"
              class="mt-4"
              @click="setEdition(edition.slug)">
              {{ edition.short_name }}
            </v-btn>
          </v-col>
 
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
const APP_URL = process.env.VUE_APP_URL
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'AppBarWaitingRoom',
  data: () => ({
    loading: false,
    loading_btn:false,
    change_edition: false,
    editions:[]
  }),

  computed: {
    ...mapGetters([
      'isLogged', 'user', 'edition', 'edition_id'
    ]),

    drawer: {
      get() {
        return this.$store.getters.drawer;
      },
      set(value) {
        this.$store.commit('setDrawer', value);
      },
    },

  },
  methods: {
    async logout() {
      await axios.post('logout').then(() =>{ 
          this.drawer = false
          this.$router.push({ name: "index"})
          this.$store.dispatch('logout')
        }).catch(error => {
          console.log(error);
        })
    },

    menu(){
      this.$store.dispatch('setDrawer', !this.$store.getters.drawer);
    },

    async changeEdition(){
      this.loading = true
      await axios.get('edition').then(response => {
        this.editions = response.data.data.editions
        this.loading = false
        this.change_edition = true
      })
    },

    async setEdition(slug){
      this.loading_btn=true
      this.$store.dispatch('setDrawer', false);
      localStorage.removeItem('convocation_form')
      localStorage.removeItem('edition')
      await axios.get('change-edition/'+slug).then(response => {
        this.data = response.data.data

        this.appbar_dark_mode = (this.data.edition.edition_customization.appbar_dark_mode)?true:false
        this.appbar_image = APP_URL + this.data.edition.edition_customization.appbar_image

        this.loading = false
        
        localStorage.setItem('edition_id', this.data.edition_id);
        localStorage.setItem('edition', this.data.edition);
        localStorage.setItem('convocation_form', this.data.convocation_form);

        this.$store
              .dispatch('edition', {
                edition: this.data.edition 
              })

        this.$store
              .dispatch('convocationForm', {
                convocation_form: this.data.convocation_form
              })


        if(this.$route.name!='home'){
          this.$router.push({ name: 'home'})
        }
        this.$store.dispatch('setDrawer', true);
        this.loading_btn=false
        this.change_edition = false
      })
    }
  }
}
</script>
<style>
.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background: linear-gradient(to right,#00a1b8 0%,#23495c 100%) !important;
}

.routerLink{
  text-decoration: none;
}

.app-bar-color {
  color: white!important;
}

.color-navigation2 {
  color: white!important;
  background-color: powderblue!important;
}

.color-navigation1 {
  color: white!important;
  background: repeating-linear-gradient(rgb(105, 105, 105),rgb(105, 105, 105));
}

.color-navigation {
  color: white !important;
  background: repeating-linear-gradient(#32378B, #A21381, #E2017B, #A6C400, #B5C500);
  /* background: repeating-linear-gradient(#000000,#176E81, #0D849A, #000000, #000000); */
  /* background: repeating-linear-gradient(#23495C, #23495C); */
}

</style>